import mutations from './mutations'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    cashiers: []
  },
  getters: {
  },
  mutations,
  actions
}
